module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAABmJLR0QAAAAAAAD5Q7t/AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH4QkCDTMIRL22LAAAABl0RVh0Q29tbWVudABDcmVhdGVkIHdpdGggR0lNUFeBDhcAAADkSURBVHja7dpBDoIwFIThFlzLFeRsrvQ+yIa76QlM8AJ4gZqQ2qnv2X/WJDQf8wpNCIGQphP3Xni6rVvtxT2uQ1Tfo7P8dGqgd9YrqkbIGoH75ShZzDi/qo+D+Qaom2AWINUyBYLpBtRAMD8CagQXe4ASwc0mmEIYp+fSDEAKYYv9+dsmuAJQNMEdwKcm5CK4BCiJ4OZTWHWKdNuA5s4CAIhysP6KU+8fjAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAH+erH+ESv3PRwMAIISQ3+YN2wlFhqEd2AAAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/icon-file.png
// module id = 1602
// module chunks = 0